/* global window */

/**
 * Deep links into the cabinet for an issue row.
 */

/**
 * Cabinet route segment after `#/cabinets/`: `connections` for welds, else `assets`.
 * @param {string} assetType - Issue row assetType (e.g. Pipe, Weld)
 * @returns {'connections'|'assets'}
 */
export const getCabinetResourceSegment = assetType => {
  const normalized = String(assetType !== null && assetType !== void 0 ? assetType : '').trim().toLowerCase();
  return normalized === 'weld' ? 'connections' : 'assets';
};

/**
 * Full URL to open an issue's form in the app (same origin as current window).
 * @param {Object} item - Issue row with formID, formTypeIdentifier, assetType
 * @param {string} [origin] - Base origin (defaults to `window.location.origin`)
 * @returns {string|null} URL or null if required fields are missing
 */
export const buildCabinetFormUrl = function buildCabinetFormUrl(item) {
  var _item$formID, _item$formTypeIdentif;
  let origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let base = '';
  if (origin != null) {
    base = String(origin).replace(/\/$/, '');
  } else if (typeof window !== 'undefined') {
    base = window.location.origin;
  }
  if (!base) {
    return null;
  }
  const formId = String((_item$formID = item === null || item === void 0 ? void 0 : item.formID) !== null && _item$formID !== void 0 ? _item$formID : '').trim();
  const formTypeIdentifier = String((_item$formTypeIdentif = item === null || item === void 0 ? void 0 : item.formTypeIdentifier) !== null && _item$formTypeIdentif !== void 0 ? _item$formTypeIdentif : '').trim();
  if (!formId || !formTypeIdentifier) {
    return null;
  }
  const segment = getCabinetResourceSegment(item === null || item === void 0 ? void 0 : item.assetType);
  const path = "#/cabinets/".concat(segment, "/").concat(encodeURIComponent(formTypeIdentifier), "/").concat(encodeURIComponent(formId));
  return "".concat(base, "/").concat(path);
};